
new Vue({
    el: '#app',
    data() {
        return {
            loaded: false,
            roadmap: null
        }
    },
    mounted() {
        axios
            .get(`/api/roadmap?lang=${document.documentElement.lang}`)
            .then(response => {
                this.roadmap = response.data;

                // init masonry effect after DOM rebuild by vuejs
                setTimeout(() => {
                    var elements = document.getElementsByClassName('grid');
                    var msnry;

                    var n = elements.length;
                    for (var i = 0; i < n; i++) {
                        msnry = new Masonry(elements[i], {
                            gutter: 40,
                            itemSelector: '.grid-item'
                        });
                    }

                    this.loaded = true;
                    
                }, 500);                
            })
            .catch(error => {
                console.log(error)
                this.roadmap = { done: [], planned: {}, early: {}, loaded: true };
            });
    }
});
